import React from 'react'

export default function SkillsItem({clave, valor}) {
    if(clave === "HP")return(
        <div className="skill--item">
            <span className="skill--item--left item--left">
                <p>{clave}</p>
            </span>
            <span className="subtitle skill--item--right item--right hp">
                <p>{valor}</p>
            </span>
        </div>
    )
  return (
      <div className="skill--item">
          <span className="skill--item--left item--left">
              <p>{clave}</p>
          </span>
          <span className="subtitle skill--item--right item--right">
              <p>{valor}</p>
          </span>
      </div>

  )
}
